import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";


import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../assets/styles/hero.css";
import "../assets/styles/productCategories.css";
import "../assets/styles/industries.css";
import defenceImg from "../assets/images/defence.png";
import audioImg from "../assets/images/audio.png";
import automobileImg from "../assets/images/automobile.png";
import telecomImg from "../assets/images/telecom.png";


const getCategoryIcon = (name = "") => {
  const n = name.toLowerCase();
  const s = (path) => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#034EA2" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      {path}
    </svg>
  );
  if (n.includes("transistor"))
    return s(<><line x1="5" y1="12" x2="11" y2="12"/><line x1="11" y1="6" x2="11" y2="18"/><line x1="11" y1="8" x2="19" y2="4"/><line x1="11" y1="16" x2="19" y2="20"/><circle cx="19" cy="4" r="1" fill="#034EA2"/><circle cx="19" cy="20" r="1" fill="#034EA2"/></>);
  if (n.includes("diode") || n.includes("rectif") || n.includes("tvs") || n.includes("zener"))
    return s(<><line x1="3" y1="12" x2="21" y2="12"/><polygon points="8,7 8,17 16,12" fill="rgba(34,80,138,0.15)" stroke="#034EA2"/><line x1="16" y1="7" x2="16" y2="17"/></>);
  if (n.includes("mosfet") || n.includes("igbt"))
    return s(<><rect x="10" y="4" width="2" height="16" rx="1"/><line x1="6" y1="8" x2="10" y2="8"/><line x1="6" y1="12" x2="10" y2="12"/><line x1="6" y1="16" x2="10" y2="16"/><line x1="3" y1="8" x2="6" y2="8"/><line x1="3" y1="16" x2="6" y2="16"/><line x1="12" y1="12" x2="21" y2="12"/></>);
  if (n.includes("thyristor") || n.includes("scr") || n.includes("triac"))
    return s(<><line x1="3" y1="12" x2="21" y2="12"/><polygon points="8,7 8,17 16,12" fill="rgba(34,80,138,0.15)" stroke="#034EA2"/><line x1="16" y1="7" x2="16" y2="17"/><line x1="12" y1="17" x2="12" y2="21"/></>);
  // default: IC chip
  return s(<><rect x="6" y="6" width="12" height="12" rx="1"/><line x1="6" y1="9" x2="3" y2="9"/><line x1="6" y1="12" x2="3" y2="12"/><line x1="6" y1="15" x2="3" y2="15"/><line x1="18" y1="9" x2="21" y2="9"/><line x1="18" y1="12" x2="21" y2="12"/><line x1="18" y1="15" x2="21" y2="15"/><line x1="9" y1="6" x2="9" y2="3"/><line x1="15" y1="6" x2="15" y2="3"/><line x1="9" y1="18" x2="9" y2="21"/><line x1="15" y1="18" x2="15" y2="21"/></>);
};

const Home = () => {
  /* ================= SEARCH ================= */
  const [searchBoxInputVal, setSearchBoxInputVal] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  /* ================= DATA ================= */
  const [categories, setCategories] = useState([]);
  const [categorySubMap, setCategorySubMap] = useState({});
  const [industry, setIndustry] = useState([]);

  /* ================= LOAD CATEGORIES + SUBCATEGORIES ================= */
  useEffect(() => {
    const loadData = async () => {
      try {
        const catRes = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/frontend/category/all`
        );
        const catData = await catRes.json();
        const cats = catData.rows || [];
        setCategories(cats);

        // Load subcategories immediately (NO hover)
        const subMap = {};
        await Promise.all(
          cats.map(async (cat) => {
            try {
              const subRes = await fetch(
                `${process.env.REACT_APP_BACKEND_URL}/frontend/subcategory?apiParams[page]=0&apiParams[searchParams]=&categoryId=${cat.categoryId}`
              );
              const subData = await subRes.json();
              subMap[cat.categoryId] = subData.rows || [];
            } catch {
              subMap[cat.categoryId] = [];
            }
          })
        );

        setCategorySubMap(subMap);
      } catch (err) {
        console.error("Load failed", err);
      }
    };

    loadData();
  }, []);

   useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/frontend/industry/all`)
      .then((res) => res.json())
      .then((data) => {
        setIndustry(data.rows || []);
      })
      .catch((err) => {
        console.error("Industry fetch failed", err);
        setIndustry([]);
      });
  }, []);

  /* ================= HERO SEARCH ================= */
  useEffect(() => {
    if (!searchBoxInputVal) {
      setSearchResults([]);
      return;
    }

    const timer = setTimeout(() => {
      fetch(
        `${process.env.REACT_APP_BACKEND_URL}/frontend/universalSearch?searchParams=${searchBoxInputVal}`
      )
        .then((res) => res.json())
        .then((data) => setSearchResults(data.results || []))
        .catch(() => setSearchResults([]));
    }, 400);

    return () => clearTimeout(timer);
  }, [searchBoxInputVal]);


  





  /* ================= FETCH INDUSTRIES ================= */
  const industryImages = {
  Defence: defenceImg,
  Audio: audioImg,
  Automobile: automobileImg,
  Telecommunications: telecomImg,
};

 

  return (
    <div style={{ width: "100%", overflow: "hidden" }}>
      {/* ================= HERO ================= */}
       <section className="hero">
        <div className="hero-content container">
          <h1>Find the Perfect Component</h1>
          <p>
            Search across our extensive catalog of high-reliability
            semiconductors and devices.
          </p>

          <div className="hero-search">
            <input
              type="search"
              placeholder="Search by category, subcategory, industry, or product..."
              value={searchBoxInputVal}
              onChange={(e) => setSearchBoxInputVal(e.target.value)}
            />
            <button>Search</button>
          </div>

          {searchResults.length > 0 && (
            <div className="hero-search-results">
              {searchResults.map((item, i) => (
                <a
                  key={i}
                  href={`${process.env.REACT_APP_BASE_URL}${item.navigate}`}
                  onClick={() => setSearchBoxInputVal("")}
                  style={{
                    display: "flex",
                    gap: "10px",
                    fontSize: "14px",
                    textDecoration: "none",
                    color: "#000000ff",
                    padding: "6px 0",
                  }}
                >
                    <span className="dot">•</span>
                   <span className="name">{item.name}</span>
                  <span className="type" style={{ opacity: 0.8 }}>
                    ({item.type.toUpperCase()})
                  </span>
                </a>
              ))}
            </div>
          )}
        
          
        </div>











      </section>

      {/* ================= PRODUCT CATEGORIES ================= */}
      <section className="product-categories">
        <div className="container">
          <div className="pc-header">
            <h2>Product Categories</h2>
            <Link to="/category" className="view-all">
              View Full Catalog →
            </Link>
          </div>

          <div className="pc-grid">
            {categories.slice(0, 8).map((cat) => {
              const subs = categorySubMap[cat.categoryId] || [];
              return (
                <div className="pc-card" key={cat.categoryId}>
                  <div style={{ marginBottom: "12px" }}>{getCategoryIcon(cat.categoryName)}</div>
                  <div className="pc-badge">
                    <Link to={`/table/category/${cat.categoryName}/all`}>{subs.length} Subcategories</Link>
                  </div>
                  <h3>{cat.categoryName}</h3>
                  <ul>
                    {subs.length > 0 ? (
                      subs.slice(0, 4).map((sub) => (
                        <li key={sub.subcatId}>
                          <Link to={`/table/category/${cat.categoryName}/${sub.subcatName}`}>
                            {sub.subcatName} <b style={{ float: "right" }}>→</b>
                          </Link>
                        </li>
                      ))
                    ) : (
                      <li className="loading-text">No subcategories</li>
                    )}
                  </ul>
                </div>
              );
            })}
            <div className="pc-card pc-view-all">
              <div className="icon">⋮⋮⋮</div>
              <h3>View All Categories</h3>
              <p>Explore our complete range of electronic components.</p>
              <Link to="/category" className="browse-all">Browse All →</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
